module.exports = __webpack_public_path__ + "img/dea-formazione-ico-didattica-digitale.3a49a434.svg";